import { useNavigate, useLocation } from "react-router-dom";

export default function PrivacyFooter() {
  const nav = useNavigate();
  const { pathname } = useLocation();

  const hideOn = ["/", "/login", "/register"];
  if (hideOn.includes(pathname)) return null;

  return (
    <footer style={styles.footer}>
      <div style={styles.linkRow}>
        <button
          type="button"
          onClick={() => nav("/feedback")}
          style={styles.link}
        >
          Feedback
        </button>
        <button
          type="button"
          onClick={() => nav("/privacy-policy")}
          style={styles.link}
        >
          Privacy Policy
        </button>
        <button
          type="button"
          onClick={() => nav("/terms-and-conditions")}
          style={styles.link}
        >
          Terms & Conditions
        </button>
      </div>
      <p style={styles.copyright}>© 2026 NextBite. All rights reserved.</p>
    </footer>
  );
}

const styles = {
  footer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    padding: "28px 16px 36px",
    borderTop: "1px solid rgba(226,232,240,0.8)",
    background: "transparent",
    marginTop: 32
  },
  linkRow: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 24
  },
  link: {
    border: "none",
    background: "transparent",
    color: "#94a3b8",
    cursor: "pointer",
    fontSize: 13,
    fontFamily: "inherit",
    transition: "color 0.2s ease"
  },
  copyright: {
    margin: 0,
    color: "#cbd5e1",
    fontSize: 13
  }
};
